import type { Entry, Track } from "./api";
import { understoodLabel, VISIBILITY_LABELS, whenLabel } from "./dates";

/**
 * Le contenu de la carte d'un point, le meme au bureau (bulle a cote de la boule) et au telephone
 * (feuille en bas) : piste et visibilite, titre, date tapee, ce que l'app a compris, note, et les
 * gestes. La piste est toujours ecrite en toutes lettres : jamais la couleur seule. Sans `onEdit`
 * (la vue d'un proche), seulement « Fermer ».
 */
export function EntryCardBody({
  entry,
  track,
  onEdit,
  onClose,
  layout,
}: {
  entry: Entry;
  track: Track | undefined;
  onEdit?: (() => void) | undefined;
  onClose: () => void;
  layout: "bubble" | "sheet";
}) {
  const color = track?.color ?? "#AEB6C8";
  return (
    <>
      <span className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.06em] text-muted-foreground">
        <span
          aria-hidden="true"
          className="size-2 rounded-full"
          style={{ background: color, boxShadow: `0 0 8px ${color}` }}
        />
        {track?.name ?? "Sans piste"} · {VISIBILITY_LABELS[entry.visibility]}
      </span>
      <strong className="font-[family-name:var(--tl-font-display)] text-[22px] font-medium leading-tight">
        {entry.title}
      </strong>
      <span className="text-sm">{whenLabel(entry)}</span>
      <span className="text-xs text-muted-foreground">{understoodLabel(entry)}</span>
      {entry.note ? (
        <span className="font-[family-name:var(--tl-font-display)] text-[15px] italic text-[#D8D2C4]">
          {entry.note}
        </span>
      ) : null}
      {layout === "sheet" ? (
        <div
          className={`mt-1.5 grid gap-2 ${onEdit === undefined ? "grid-cols-1" : "grid-cols-2"}`}
        >
          {onEdit === undefined ? null : (
            <button
              className="min-h-11 rounded-xl bg-primary text-[15px] font-semibold text-primary-foreground"
              onClick={onEdit}
              type="button"
            >
              Modifier
            </button>
          )}
          <button
            className="min-h-11 rounded-xl border border-input text-[15px]"
            onClick={onClose}
            type="button"
          >
            Fermer
          </button>
        </div>
      ) : (
        <div className="mt-1 flex gap-3.5 text-sm">
          {onEdit === undefined ? null : (
            <button
              className="min-h-11 font-medium text-tl-accent underline"
              onClick={onEdit}
              type="button"
            >
              Modifier
            </button>
          )}
          <button
            className="min-h-11 text-muted-foreground underline"
            onClick={onClose}
            type="button"
          >
            Fermer
          </button>
        </div>
      )}
    </>
  );
}
